module.exports = __webpack_public_path__ + "static/media/sha2.e7fe970a.webp";